import React, { useEffect, useRef, useState } from "react";
import QurealSection from "../common/QurealSection";
import log from "cslog";
import styles from "./styles/ContentCalender.module.css";
import {
    Button,
    Checkbox,
    ConfigProvider,
    Drawer,
    Popover,
    Radio,
    Space,
    Spin,
    Grid,
    theme,
} from "antd";
import { Calendar } from "antd";
import OneDay from "../ai_home/OneDay";

import dayjs from "dayjs";
import minMax from "dayjs/plugin/minMax";
import weekOfYear from "dayjs/plugin/weekOfYear";

import {
    DownOutlined,
    FilterOutlined,
    LeftOutlined,
    PlusOutlined,
    RightOutlined,
    UpOutlined,
} from "@ant-design/icons";
import { useItemsFine } from "../actions/app/items";

import moment from "moment";
import ContentCalenderForm from "./ContentCalenderForm";
import { getHeroIcon } from "../_helpers/heroicons";
import { startCase } from "lodash";
import AddEventModal from "./AddEventModal";
import NewAddPanel, { SchedulePicker } from "./NewAddPanel";
import CalendarCardsRenderer from "./CalendarCardRenderer";

const { useBreakpoint } = Grid;

const WEEK_DAYS = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
];

dayjs.extend(minMax);
dayjs.extend(weekOfYear);

moment.updateLocale("en", {
    weekdaysMin: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
    ],
});

const isAddButtonAtTop = true;

// ---------------------------------------------------------------------------
// Data processors (pure, no component deps)
// ---------------------------------------------------------------------------

export function processEvents(data) {
    const out = {};
    data.forEach((item) => {
        const dt = item.date ? new Date(item.date) : null;
        if (dt) {
            const month = dt.getMonth();
            const day = dt.getDate();
            const out_month = out[month] || {};
            const out_day = out_month[day] || [];
            out[month] = {
                ...out_month,
                [day]: [
                    ...out_day,
                    {
                        ...item,
                        dt,
                        platform: "facebook",
                        content_type: "facebook_post",
                        content: item.name,
                        img: item.feature_image,
                        tags: ["festival"],
                        type: "festival",
                        status: "generated",
                        generated_data: {
                            canvas: {
                                design: {
                                    preset_id:
                                        "0e0c5b74-e8d5-4237-be1e-8e4ae3dded98",
                                    primary_tag: item.primary_tag?.name,
                                    primary_tag_id: item.primary_tag?.id,
                                    prefill: {},
                                },
                            },
                        },
                    },
                ],
            };
        }
    });
    return out;
}

export function processEntries(data) {
    const out = {};
    data.forEach((item) => {
        log.d(item, "Entry in CCN");
        const dt = item.date ? new Date(item.date) : null;
        if (dt) {
            const month = dt.getMonth();
            const day = dt.getDate();
            const out_month = out[month] || {};
            const out_day = out_month[day] || [];

            let one = {
                dt,
                platform: item.platform || "",
                content_type: item.content_type || "",
                content: item?.idea?.post_idea || "Idea",
                tags: [item.idea?.post_type || "entry"],
            };

            if (item.idea_processed) {
                one = {
                    ...one,
                    img: item.idea_processed?.template_preview,
                };
            }

            if (item?.generated_data?.media) {
                one = {
                    ...one,
                    img_url:
                        item.generated_data.media?.[0]?.preview_url ||
                        item.generated_data.media?.[0]?.public_url,
                    content: item.generated_data?.caption || "External Post",
                    tags: ["External Post"],
                    type: "external_post",
                    media_type: item.generated_data?.media?.[0]?.preview_url
                        ? "video"
                        : "image",
                };
            }

            out[month] = {
                ...out_month,
                [day]: [
                    ...out_day,
                    {
                        ...item,
                        ...one,
                        type: one?.type || "entry",
                    },
                ],
            };
        }
    });
    log.d(out, "Processed Entries");
    return out;
}

// ---------------------------------------------------------------------------
// CalendarHeader
// ---------------------------------------------------------------------------

function CalendarHeader({
    value: current,
    onChange,
    isMobile,
    mode,
    setMode,
    setRange,
    loadingEntries,
    loadingEvent,
    me,
    filters,
    setFilters,
    onCreateClick,
}) {
    const dayLabel = (() => {
        const d = dayjs(current);
        if (d.isSame(dayjs(), "day"))
            return `Today, ${d.format("MMM D, YYYY")}`;
        if (d.isSame(dayjs().subtract(1, "day"), "day"))
            return `Yesterday, ${d.format("MMM D, YYYY")}`;
        if (d.isSame(dayjs().add(1, "day"), "day"))
            return `Tomorrow, ${d.format("MMM D, YYYY")}`;
        return d.format("dddd, MMM D, YYYY");
    })();

    const handleModeChange = (newMode) => {
        setMode(newMode);
        setRange(
            newMode === "month"
                ? getCurrentMonthRange(current)
                : newMode === "week"
                ? getWeekRange(current)
                : getDayRange(current)
        );
    };

    return (
        <div>
            {isMobile && (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        paddingTop: "12px",
                        paddingLeft: "15px",
                        paddingRight: "15px",
                    }}
                >
                    <Radio.Group
                        value={mode}
                        onChange={(e) => handleModeChange(e.target.value)}
                    >
                        <Radio.Button value="month">Month</Radio.Button>
                        <Radio.Button value="week">Week</Radio.Button>
                        <Radio.Button value="day">Day</Radio.Button>
                    </Radio.Group>
                    <Button onClick={onCreateClick} icon={<PlusOutlined />}>
                        Create
                    </Button>
                </div>
            )}
            <div className={styles.header}>
                <div className={styles.header_left}>
                    <Space.Compact size={isMobile ? "small" : "middle"}>
                        <Button
                            shape="circle"
                            type="text"
                            icon={<LeftOutlined />}
                            onClick={() => {
                                const next = current.add(-1, mode);
                                onChange(next);
                                setRange(
                                    mode === "month"
                                        ? getCurrentMonthRange(next)
                                        : mode === "week"
                                        ? getWeekRange(next)
                                        : getDayRange(next)
                                );
                            }}
                        />
                        <Button
                            shape="circle"
                            type="text"
                            icon={<RightOutlined />}
                            onClick={() => {
                                const next = current.add(1, mode);
                                onChange(next);
                                setRange(
                                    mode === "month"
                                        ? getCurrentMonthRange(next)
                                        : mode === "week"
                                        ? getWeekRange(next)
                                        : getDayRange(next)
                                );
                            }}
                        />
                    </Space.Compact>

                    <div className={styles.header_title}>
                        {!isMobile && mode !== "day" && "Content Calender "}
                        {mode === "month" && (
                            <span>
                                {current.format(
                                    isMobile ? "MMM YYYY" : "MMMM YYYY"
                                )}
                            </span>
                        )}
                        {mode === "week"
                            ? `Week ${current.week()}, ${current.format(
                                  isMobile ? "MMM YYYY" : "MMM YYYY"
                              )}`
                            : null}
                        {mode === "day" ? dayLabel : null}
                    </div>
                    {(loadingEntries || loadingEvent) && <Spin />}
                </div>

                <div
                    className={styles.header_right}
                    style={
                        isMobile
                            ? { display: "flex", flexDirection: "column" }
                            : {}
                    }
                >
                    {!isMobile && (
                        <Radio.Group
                            value={mode}
                            onChange={(e) => handleModeChange(e.target.value)}
                            size={isMobile ? "small" : "middle"}
                        >
                            <Radio.Button value="month">Month</Radio.Button>
                            <Radio.Button value="week">Week</Radio.Button>
                            <Radio.Button value="day">Day</Radio.Button>
                        </Radio.Group>
                    )}

                    <Space wrap size={isMobile ? "small" : "middle"}>
                        {!isMobile && (
                            <Button
                                onClick={onCreateClick}
                                icon={<PlusOutlined />}
                            >
                                Create
                            </Button>
                        )}

                        <CalendarFilters
                            value={filters}
                            onChange={setFilters}
                            isMobile={isMobile}
                        />
                        <ContentCalenderForm
                            me={me}
                            trigger={
                                <Button
                                    icon={getHeroIcon("sparkles", {
                                        width: "15px",
                                    })}
                                    type="primary"
                                >
                                    {!isMobile && "Generate"}
                                </Button>
                            }
                        />
                    </Space>
                </div>
            </div>
        </div>
    );
}

// ---------------------------------------------------------------------------
// CalendarDayCell — renders a single calendar cell (used by all view modes)
// ---------------------------------------------------------------------------

function CalendarDayCell({
    mode,
    current,
    options = {},
    eventItems,
    entryItems,
    me,
    setCellActionModal,
    wrapperWidth,
}) {
    const { token } = theme.useToken();
    const {
        suppressCards = false,
        renderOnlyCards = false,
        isMobile = false,
        hideButton = null,
    } = options;

    const listDataEvents = eventItems[current.month()]?.[current.date()] || [];
    const listDataEntries = entryItems[current.month()]?.[current.date()] || [];

    const filteredEvents = listDataEvents.filter(
        (event) =>
            !listDataEntries.some((entry) => entry.ref_event === event.id)
    );
    const listData = [...filteredEvents, ...listDataEntries];

    const isToday = current.isSame(dayjs(), "date");
    const isPastDay = current.isBefore(dayjs(), "day");

    if (renderOnlyCards) {
        if (suppressCards) return null;
        return (
            <CalendarCardsRenderer
                items={listData}
                me={me}
                isMobile={isMobile}
                collapsible={true}
                className={styles.list}
                compactStatus={wrapperWidth < 1400}
            />
        );
    }

    const onAddClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setCellActionModal({
            open: true,
            date: current?.toDate?.() || new Date(),
        });
    };

    return (
        <div
            className={`${styles.calendercell}`}
            data-today={isToday ? "true" : undefined}
        >
            {isPastDay && <div className={styles.pastDayOverlay} />}

            <div className={styles.cellContent}>
                {mode === "month" && (
                    <div className={styles.calendarDate}>
                        <span
                            className={`${styles.day} ${
                                isToday ? styles.todayDay : ""
                            }`}
                        >
                            {current.date()} {current.format("MMM")}
                        </span>
                    </div>
                )}

                {hideButton}

                {isAddButtonAtTop && !isPastDay && (
                    <div
                        className={styles.cellAddButtonRow}
                        style={{ paddingBottom: "8px" }}
                    >
                        <Button
                            block
                            size="small"
                            type="dashed"
                            icon={
                                <PlusOutlined
                                    style={{ color: token.colorPrimary }}
                                />
                            }
                            className={styles.cellAddButton}
                            onClick={onAddClick}
                            aria-label="Add"
                        />
                    </div>
                )}

                {!suppressCards ? (
                    <CalendarCardsRenderer
                        items={listData}
                        me={me}
                        collapsible={true}
                        className={styles.list}
                        compactStatus={wrapperWidth < 1400}
                    />
                ) : null}

                {!isAddButtonAtTop && !isPastDay && (
                    <div
                        className={styles.cellAddButtonRow}
                        style={{ paddingTop: "8px" }}
                    >
                        <Button
                            block
                            size="small"
                            type="dashed"
                            icon={
                                <PlusOutlined
                                    style={{ color: token.colorPrimary }}
                                />
                            }
                            className={styles.cellAddButton}
                            onClick={onAddClick}
                            aria-label="Add"
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

// ---------------------------------------------------------------------------
// ContentCalenderNew — main component (state + thin render wrappers)
// ---------------------------------------------------------------------------

function ContentCalenderNew({ me = {}, wrapper_style = {} }) {
    const { token } = theme.useToken();
    const screens = useBreakpoint();
    const isMobile = !screens.sm; // true when < 576px

    const [range, setRange] = useState(() => {
        const today = new Date();
        return isMobile
            ? getRollingRange(today, 7)
            : getCurrentMonthRange(today);
    });

    const [filters, setFilters] = useState({
        platforms: PLATFORMS,
        festivals: [5, 4, 3],
    });

    const {
        isSuccess: successEvent,
        isFetching: loadingEvent,
        data: dataEvent,
    } = useItemsFine(
        "qdb_event",
        `limit=-1&fields=id,date,name,primary_tag.name,primary_tag.id,feature_image&filter=${JSON.stringify(
            {
                _or: [
                    {
                        event_type: "festival",
                        status: { _eq: "published" },
                        date: { _between: range },
                        star: { _in: filters.festivals },
                    },
                    {
                        event_type: "user_created",
                        organization: { _eq: me.selected_org?.id },
                        date: { _between: range },
                    },
                ],
            }
        )}`,
        true,
        false
    );

    const {
        isSuccess: successEntries,
        isFetching: loadingEntries,
        data: dataEntries,
    } = useItemsFine(
        "qdb_calendar_entries",
        `limit=-1&fields=*,platforms.*&filter=${JSON.stringify({
            organization: { _eq: me.selected_org?.id },
            platforms: {
                post_type: {
                    _in: filters.platforms.map((p) => p.toUpperCase()),
                },
            },
            date: { _between: range },
        })}`,
        true,
        false
    );

    log.d(dataEvent, "Event Data in CCN");
    log.d(filters, "filters in CCN");
    log.d(range, "selected range");
    log.d(me, "me in CCN");

    const [mode, setMode] = useState("month");
    const [dayValue, setDayValue] = useState(dayjs());
    const [eventItems, setEventItems] = useState({});
    const [entryItems, setEntryItems] = useState({});
    const [cellActionModal, setCellActionModal] = useState({
        open: false,
        date: null,
    });

    const wrapperRef = useRef(null);
    const [wrapperWidth, setWrapperWidth] = useState(0);

    useEffect(() => {
        if (!wrapperRef.current) return;
        const observer = new ResizeObserver((entries) => {
            for (let entry of entries) {
                setWrapperWidth(entry.contentRect.width);
            }
        });
        observer.observe(wrapperRef.current);
        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        if (successEvent && dataEvent) {
            setEventItems(processEvents(dataEvent));
        }
    }, [successEvent, dataEvent]);

    useEffect(() => {
        if (successEntries && dataEntries) {
            setEntryItems(processEntries(dataEntries));
        }
    }, [successEntries, dataEntries]);

    const dayHasItems = (d) => {
        const e = eventItems[d.month()]?.[d.date()]?.length || 0;
        const f = entryItems[d.month()]?.[d.date()]?.length || 0;
        return e + f > 0;
    };

    // Thin closure so child components keep the same header(args) call signature
    const header = ({ value: current, onChange, onTypeChange }) => (
        <CalendarHeader
            value={current}
            onChange={onChange}
            isMobile={isMobile}
            mode={mode}
            setMode={setMode}
            setRange={setRange}
            loadingEntries={loadingEntries}
            loadingEvent={loadingEvent}
            me={me}
            filters={filters}
            setFilters={setFilters}
            onCreateClick={() =>
                setCellActionModal({ open: true, date: new Date() })
            }
        />
    );

    // Thin closure so child components keep the same dateFullCellRender(mode, date, opts) signature
    const dateFullCellRender = (cellMode, current, options = {}) => (
        <CalendarDayCell
            mode={cellMode}
            current={current}
            options={options}
            eventItems={eventItems}
            entryItems={entryItems}
            me={me}
            setCellActionModal={setCellActionModal}
            wrapperWidth={wrapperWidth}
        />
    );

    const getDayItems = () => {
        const current = dayjs(dayValue);
        const listDataEvents =
            eventItems[current.month()]?.[current.date()] || [];
        const listDataEntries =
            entryItems[current.month()]?.[current.date()] || [];
        const filteredEvents = listDataEvents.filter(
            (event) =>
                !listDataEntries.some((entry) => entry.ref_event === event.id)
        );
        return [...filteredEvents, ...listDataEntries];
    };

    return (
        <QurealSection wrapper_style={wrapper_style}>
            <div ref={wrapperRef} className={styles.wrapper}>
                {mode === "week" && !isMobile && (
                    <CalendarWeekly
                        dateFullCellRender={dateFullCellRender}
                        header={header}
                    />
                )}
                {mode === "week" && isMobile && (
                    <CalendarMobileWeekly
                        header={header}
                        setRange={setRange}
                        isMobile={isMobile}
                        dayHasItems={dayHasItems}
                        dateFullCellRender={dateFullCellRender}
                    />
                )}
                {mode === "month" && !isMobile && (
                    <CalendarMonthly
                        header={header}
                        setRange={setRange}
                        dateFullCellRender={dateFullCellRender}
                        dayHasItems={dayHasItems}
                    />
                )}
                {mode === "month" && isMobile && (
                    <CalendarMobileMonthly
                        header={header}
                        setRange={setRange}
                        isMobile={isMobile}
                        dayHasItems={dayHasItems}
                        dateFullCellRender={dateFullCellRender}
                    />
                )}
                {mode === "day" && (
                    <>
                        {header({
                            value: dayjs(dayValue),
                            type: "day",
                            onChange: (newVal) => {
                                setDayValue(dayjs(newVal));
                                setRange(getDayRange(newVal));
                            },
                            onTypeChange: () => {},
                        })}
                        <div
                            style={{
                                border: `1px solid ${token.colorBorder}`,
                            }}
                        >
                            <OneDay
                                me={me}
                                date={dayValue}
                                showHeader={false}
                                items={getDayItems()}
                                onAddClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    setCellActionModal({
                                        open: true,
                                        date:
                                            dayValue?.toDate?.() || new Date(),
                                    });
                                }}
                            />
                        </div>
                    </>
                )}

                <NewAddPanel
                    action={cellActionModal}
                    setCellActionModal={setCellActionModal}
                    me={me}
                />
            </div>
        </QurealSection>
    );
}

export default ContentCalenderNew;

// ---------------------------------------------------------------------------
// CalendarMonthly
// ---------------------------------------------------------------------------

const CalendarMonthly = ({
    header,
    setRange,
    dateFullCellRender,
    dayHasItems = () => false,
}) => {
    const onPanelChange = (value) => {
        setRange(getCurrentMonthRange(value));
    };

    const onSelect = (value) => {
        setRange(getCurrentMonthRange(value));
    };

    const [viewValue, setViewValue] = useState(dayjs());
    const [expandedRows, setExpandedRows] = useState(new Set());
    // const viewYear = viewValue?.year();
    // const viewMonth = viewValue?.month();

    useEffect(() => {
        setExpandedRows(new Set());
    }, [viewValue?.year(), viewValue?.month()]);
    // }, [viewYear, viewMonth]);

    const getGridStart = (view) => {
        const v = moment(view || viewValue);
        const firstOfMonth = v.clone().startOf("month");
        return firstOfMonth.clone().startOf("week");
    };

    const getRowIndexForDate = (view, date) => {
        const gridStart = getGridStart(view);
        const diffDays = dayjs(date)
            .startOf("day")
            .diff(dayjs(gridStart.toDate()).startOf("day"), "day");
        return Math.floor(diffDays / 7);
    };

    const currentWeekStart = dayjs(moment().startOf("week").toDate());

    return (
        <ConfigProvider
            calendar={{
                showWeekNumber: true,
            }}
        >
            <Calendar
                fullscreen={true}
                mode="month"
                className={styles.myCustomCalendar}
                locale={{
                    lang: {
                        locale: "en_US",
                        shortWeekDays: [
                            "Sunday",
                            "Monday",
                            "Tuesday",
                            "Wednesday",
                            "Thursday",
                            "Friday",
                            "Saturday",
                        ],
                    },
                }}
                onPanelChange={onPanelChange}
                onSelect={onSelect}
                headerRender={(args) => {
                    try {
                        if (args?.value) setViewValue(args.value);
                    } catch {}
                    return header(args);
                }}
                dateFullCellRender={(current) => {
                    const isPastDay = current.isBefore(dayjs(), "day");

                    if (isPastDay) {
                        setTimeout(() => {
                            const dateCell = document
                                .querySelector(
                                    `[title="${current.format("YYYY-MM-DD")}"]`
                                )
                                ?.closest(".ant-picker-cell");
                            if (dateCell) {
                                dateCell.classList.add("cell-past-date");
                            }
                        }, 0);
                    }

                    const rowIdx = getRowIndexForDate(viewValue, current);
                    const gridStart = getGridStart(viewValue);
                    const rowStartDayjs = dayjs(
                        gridStart
                            .clone()
                            .add(rowIdx * 7, "days")
                            .toDate()
                    );

                    const isNonCurrentWeek = !rowStartDayjs.isSame(
                        currentWeekStart,
                        "day"
                    );

                    let rowHasContent = false;
                    for (let i = 0; i < 7; i++) {
                        if (dayHasItems(rowStartDayjs.add(i, "day"))) {
                            rowHasContent = true;
                            break;
                        }
                    }

                    const isExpanded = expandedRows.has(
                        `${rowStartDayjs.format("YYYY-MM-DD")}`
                    );

                    const suppressCards =
                        isNonCurrentWeek && rowHasContent && !isExpanded;

                    const isRowMiddleCell = current.isSame(
                        rowStartDayjs.add(3, "day"),
                        "day"
                    );

                    const hideButton =
                        isNonCurrentWeek &&
                        rowHasContent &&
                        isExpanded &&
                        isRowMiddleCell ? (
                            <div style={{ padding: "4px 8px 6px" }}>
                                <Button
                                    block
                                    type="dashed"
                                    size="small"
                                    icon={
                                        <UpOutlined style={{ fontSize: 9 }} />
                                    }
                                    className={styles.expandRowButton}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setExpandedRows((prev) => {
                                            const next = new Set(prev);
                                            next.delete(
                                                `${rowStartDayjs.format(
                                                    "YYYY-MM-DD"
                                                )}`
                                            );
                                            return next;
                                        });
                                    }}
                                >
                                    Hide
                                </Button>
                            </div>
                        ) : null;

                    const base = dateFullCellRender("month", current, {
                        suppressCards,
                        hideButton,
                    });

                    return (
                        <div
                            className={`${styles.monthCellWrap}`}
                            data-week-row={rowIdx}
                        >
                            <div className={styles.monthCellInner}>{base}</div>

                            {isNonCurrentWeek &&
                                rowHasContent &&
                                !isExpanded &&
                                isRowMiddleCell && (
                                    <div className={styles.rowButtonSlot}>
                                        <Button
                                            block
                                            type="dashed"
                                            size="small"
                                            icon={
                                                <DownOutlined
                                                    style={{ fontSize: 9 }}
                                                />
                                            }
                                            className={styles.expandRowButton}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setExpandedRows((prev) => {
                                                    const next = new Set(prev);
                                                    next.add(
                                                        `${rowStartDayjs.format(
                                                            "YYYY-MM-DD"
                                                        )}`
                                                    );
                                                    return next;
                                                });
                                            }}
                                        >
                                            Show
                                        </Button>
                                    </div>
                                )}
                        </div>
                    );
                }}
            />
        </ConfigProvider>
    );
};

// ---------------------------------------------------------------------------
// CalendarWeekly
// ---------------------------------------------------------------------------

function CalendarWeekly({ dateFullCellRender, header }) {
    const [selected_day, setSelectedDay] = useState(dayjs());
    const [week_days, setWeekDays] = useState([]);

    useEffect(() => {
        const today = selected_day;
        log.d(today, "today in header onChange");
        const startOfWeek = today.startOf("week");

        const weekDates = [];
        for (let i = 0; i < 7; i++) {
            weekDates.push(dayjs(startOfWeek.add(i, "day")));
        }
        log.d(weekDates, "weekDates in header onChange");
        setWeekDays(weekDates);
    }, [selected_day]);

    return (
        <>
            {header({
                value: selected_day,
                type: "month",
                onChange: (new_one) => {
                    log.d(new_one, "new_one in header onChange");
                    setSelectedDay(new_one);
                },
            })}
            <div className={styles.wc_wrapper}>
                {week_days?.map((day, index) => {
                    const isToday = day.isSame(dayjs(), "date");
                    const isPastDay = day.isBefore(dayjs(), "day");

                    return (
                        <div
                            key={day}
                            className={`${styles.wc_day} ${
                                isPastDay ? styles.pastDay : ""
                            }`}
                        >
                            <div className={styles.wc_day_name}>
                                {WEEK_DAYS[index]}
                            </div>
                            <hr />
                            <div
                                className={
                                    isToday ? styles.wc_today : styles.wc_date
                                }
                            >
                                {day.format("D MMM")}
                            </div>
                            {dateFullCellRender("week", day, {})}
                        </div>
                    );
                })}
            </div>
        </>
    );
}

// ---------------------------------------------------------------------------
// CalendarMobileMonthly
// ---------------------------------------------------------------------------

const CalendarMobileMonthly = ({
    header,
    setRange,
    isMobile,
    dayHasItems,
    dateFullCellRender,
}) => {
    const [currentDate, setCurrentDate] = useState(dayjs());
    const containerRef = useRef(null);

    const monthStart = currentDate.startOf("month");
    const monthEnd = currentDate.endOf("month");
    const isCurrentMonth = currentDate.isSame(dayjs(), "month");

    // const currentYear = currentDate?.year();
    // const currentMonth = currentDate?.month();

    const initialStart = isCurrentMonth
        ? dayjs().startOf("day")
        : monthStart.startOf("day");
    const [visibleStart, setVisibleStart] = useState(initialStart);
    const [visibleEnd, setVisibleEnd] = useState(
        dayjs.min(initialStart.add(6, "day"), monthEnd)
    );

    useEffect(() => {
        const start = isCurrentMonth ? dayjs().startOf("day") : monthStart;
        const end = dayjs.min(start.add(6, "day"), monthEnd);
        setVisibleStart(start);
        setVisibleEnd(end);
    }, [currentDate?.year(), currentDate?.month()]);
    // }, [currentYear, currentMonth, isCurrentMonth, monthStart, monthEnd]);

    useEffect(() => {
        if (!visibleStart || !visibleEnd) return;
        setRange([visibleStart.startOf("day"), visibleEnd.endOf("day")]);
    }, [visibleStart, visibleEnd, setRange]);

    const buildDates = (start, end) => {
        const out = [];
        let d = start.startOf("day");
        while (d.isBefore(end, "day") || d.isSame(end, "day")) {
            const hasItems = dayHasItems ? dayHasItems(d) : false;
            out.push({
                date: d,
                hasItems,
                isToday: d.isSame(dayjs(), "date"),
                isPast: d.isBefore(dayjs(), "day"),
            });
            d = d.add(1, "day");
        }
        return out;
    };

    const dates = buildDates(visibleStart, visibleEnd);

    const groupedDates = [];
    let bucket = [];
    for (const d of dates) {
        if (!d.hasItems) {
            bucket.push(d);
        } else {
            if (bucket.length) {
                groupedDates.push({ type: "empty", range: bucket });
                bucket = [];
            }
            groupedDates.push({ type: "event", day: d });
        }
    }
    if (bucket.length) groupedDates.push({ type: "empty", range: bucket });

    const loadPrevWeek = () => {
        if (visibleStart.isSame(monthStart, "day")) return;
        const el = containerRef.current;
        if (!el) return;
        const prevHeight = el.scrollHeight;

        const candidate = visibleStart.subtract(7, "day");
        const newStart = candidate.isBefore(monthStart, "day")
            ? monthStart
            : candidate;

        setVisibleStart(newStart);

        setTimeout(() => {
            const newHeight = el.scrollHeight;
            el.scrollTop += newHeight - prevHeight;
        }, 0);
    };

    const canLoadNextWeek = visibleEnd.isBefore(monthEnd, "day");
    const loadNextWeek = () => {
        if (!canLoadNextWeek) return;
        const candidate = visibleEnd.add(7, "day");
        setVisibleEnd(
            candidate.isAfter(monthEnd, "day") ? monthEnd : candidate
        );
    };

    const onScroll = (e) => {
        if (e.currentTarget.scrollTop < 40) loadPrevWeek();
    };

    const mobileHeader = {
        value: currentDate,
        type: "month",
        onChange: (date) => {
            const next = dayjs(date);
            setCurrentDate(next);
            const start = next.isSame(dayjs(), "month")
                ? dayjs().startOf("day")
                : next.startOf("month");
            const end = dayjs.min(start.add(6, "day"), next.endOf("month"));
            setVisibleStart(start);
            setVisibleEnd(end);
            setRange([start.startOf("day"), end.endOf("day")]);
        },
        onTypeChange: () => {},
    };

    return (
        <div className={styles.mobileMonthlyWrapper}>
            {header(mobileHeader)}
            <div
                ref={containerRef}
                className={styles.mobileMonthlyContainer}
                onScroll={onScroll}
            >
                {groupedDates.map((group, idx) =>
                    group.type === "empty" ? (
                        <div
                            key={`empty-${idx}`}
                            className={styles.mobileEmptyRange}
                            data-today={
                                group.range.some((d) => d.isToday)
                                    ? "true"
                                    : undefined
                            }
                        >
                            {group.range.length === 1
                                ? group.range[0].date.format("D MMM")
                                : `${group.range[0].date.format(
                                      "D MMM"
                                  )} – ${group.range[
                                      group.range.length - 1
                                  ].date.format("D MMM")}`}
                        </div>
                    ) : (
                        <div
                            key={group.day.date.format("YYYY-MM-DD")}
                            className={`${styles.mobileDayRow} ${
                                group.day.isPast ? styles.mobilePastDay : ""
                            }`}
                            data-today={group.day.isToday ? "true" : undefined}
                        >
                            <div className={styles.mobileDateColumn}>
                                <div className={styles.mobileDayName}>
                                    {group.day.date.format("ddd")}
                                </div>
                                <div
                                    className={`${styles.mobileDateNumber} ${
                                        group.day.isToday
                                            ? styles.mobileToday
                                            : ""
                                    }`}
                                >
                                    {group.day.date.date()}
                                </div>
                            </div>

                            <div className={styles.mobileCardsColumn}>
                                {dateFullCellRender?.("month", group.day.date, {
                                    renderOnlyCards: true,
                                    isMobile: true,
                                })}
                            </div>
                        </div>
                    )
                )}

                {canLoadNextWeek && (
                    <div className={styles.mobileLoadMoreWrap}>
                        <Button
                            onClick={loadNextWeek}
                            type="link"
                            icon={<DownOutlined />}
                            iconPosition="end"
                        >
                            Load more
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
};

// ---------------------------------------------------------------------------
// CalendarMobileWeekly
// ---------------------------------------------------------------------------

const CalendarMobileWeekly = ({
    header,
    setRange,
    isMobile,
    dayHasItems,
    dateFullCellRender,
}) => {
    const [currentWeekStart, setCurrentWeekStart] = useState(() => {
        const today = dayjs();
        const currentDayOfWeek = today.day();
        const daysToMonday = currentDayOfWeek === 0 ? 6 : currentDayOfWeek - 1;
        return today.subtract(daysToMonday, "day");
    });

    const getCurrentWeekDates = () => {
        const weekDates = [];
        for (let i = 0; i < 7; i++) {
            const date = currentWeekStart.add(i, "day");
            const hasItems = dayHasItems ? dayHasItems(date) : false;
            weekDates.push({
                date,
                hasItems,
                isToday: date.isSame(dayjs(), "date"),
                isPast: date.isBefore(dayjs(), "day"),
            });
        }
        return weekDates;
    };

    const weekDates = getCurrentWeekDates();
    const groupedDates = [];
    let tempRange = [];

    weekDates.forEach((d) => {
        if (!d.hasItems) {
            tempRange.push(d);
        } else {
            if (tempRange.length > 0) {
                groupedDates.push({ type: "empty", range: tempRange });
                tempRange = [];
            }
            groupedDates.push({ type: "event", day: d });
        }
    });

    if (tempRange.length > 0) {
        groupedDates.push({ type: "empty", range: tempRange });
    }

    const mobileWeeklyHeader = {
        value: currentWeekStart,
        type: "week",
        onChange: (date) => {
            const selectedDay = dayjs(date);
            const dayOfWeek = selectedDay.day();
            const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
            const weekStart = selectedDay.subtract(daysToMonday, "day");

            setCurrentWeekStart(weekStart);
            setRange([weekStart, weekStart.endOf("week")]);
        },
        onTypeChange: () => {},
    };

    return (
        <div className={styles.mobileWeeklyWrapper}>
            <div className={styles.stickyHeader}>
                {header(mobileWeeklyHeader)}
            </div>

            <div className={styles.mobileWeeklyNavigation}>
                <div className={styles.weekRangeDisplay}>
                    {currentWeekStart.format("D MMM")} -{" "}
                    {currentWeekStart.add(6, "day").format("D MMM YYYY")}
                </div>
            </div>

            <div className={styles.mobileWeeklyContainer}>
                {groupedDates.map((group, idx) =>
                    group.type === "empty" ? (
                        <div key={idx} className={styles.mobileEmptyRange}>
                            {group.range.length === 1
                                ? `${group.range[0].date.format(
                                      "ddd"
                                  )} ${group.range[0].date.format("D MMM")}`
                                : `${group.range[0].date.format(
                                      "ddd D MMM"
                                  )} – ${group.range[
                                      group.range.length - 1
                                  ].date.format("ddd D MMM")}`}
                        </div>
                    ) : (
                        <div
                            key={group.day.date.format("YYYY-MM-DD")}
                            className={`${styles.mobileDayRow} ${
                                group.day.isPast ? styles.mobilePastDay : ""
                            }`}
                        >
                            <div className={styles.mobileDateColumn}>
                                <div className={styles.mobileDayName}>
                                    {group.day.date.format("ddd")}
                                </div>
                                <div
                                    className={`${styles.mobileDateNumber} ${
                                        group.day.isToday
                                            ? styles.mobileToday
                                            : ""
                                    }`}
                                >
                                    {group.day.date.date()}
                                </div>
                                <div className={styles.mobileDateMonth}>
                                    {group.day.date.format("MMM")}
                                </div>
                            </div>

                            <div className={styles.mobileCardsColumn}>
                                {dateFullCellRender?.("week", group.day.date, {
                                    renderOnlyCards: true,
                                    isMobile: true,
                                })}
                            </div>
                        </div>
                    )
                )}
            </div>
        </div>
    );
};

// ---------------------------------------------------------------------------
// Date range helpers
// ---------------------------------------------------------------------------

function getCurrentMonthRange(dt) {
    const d = dayjs(dt);
    const gridStart = d.startOf("month").startOf("week");
    const gridEnd = d.endOf("month").endOf("week");
    return [gridStart, gridEnd];
}

function getWeekRange(dt) {
    const start = dayjs(dt).startOf("week");
    return [start, start.endOf("week")];
}

function getDayRange(dt) {
    const d = dayjs(dt);
    return [d.startOf("day"), d.endOf("day")];
}

function getRollingRange(dt, days = 7) {
    const start = dayjs(dt).startOf("day");
    return [start, start.add(days - 1, "day").endOf("day")];
}

// ---------------------------------------------------------------------------
// Platform / festival constants
// ---------------------------------------------------------------------------

const PLATFORMS = [
    "instagram_post",
    "instagram_story",
    "instagram_reel",
    "facebook_post",
    "facebook_story",
    "linkedin_post",
    "x_post",
    "blog_post",
];
const PLATFORMS_OPTIONS = PLATFORMS.map((el) => ({
    label: startCase(el),
    value: el,
}));

const FESTIVALS = [5, 4, 3, 2, 1];
const FESTIVALS_OPTIONS = FESTIVALS.map((el) => ({
    label: `${el} ⭐`,
    value: el,
}));

// ---------------------------------------------------------------------------
// CalendarFilters
// ---------------------------------------------------------------------------

function CalendarFilters({
    value = { platforms: [], festivals: [], posting_status: [] },
    onChange = () => {},
    isMobile,
    trigger = <Button icon={<FilterOutlined />} />,
}) {
    const [open, setOpen] = useState(false);
    const [platforms, setPlatforms] = useState(value.platforms || []);
    const [festivals, setFestivals] = useState(value.festivals || []);

    const apply = () => {
        onChange({ platforms, festivals });
        setOpen(false);
    };

    const filterContent = (
        <div className={styles.filterContent}>
            <div className={styles.filterSections}>
                <div className={styles.filterSection}>
                    <Checkbox
                        checked={
                            festivals?.length === FESTIVALS.length &&
                            FESTIVALS.every((el) => festivals.includes(el))
                        }
                        indeterminate={
                            festivals?.length > 0 &&
                            festivals?.length < FESTIVALS.length
                        }
                        onChange={(e) =>
                            setFestivals(e.target.checked ? FESTIVALS : [])
                        }
                    >
                        <h4 className={styles.filter_heading}>
                            Festival Posts
                        </h4>
                    </Checkbox>
                    <Checkbox.Group
                        options={FESTIVALS_OPTIONS}
                        value={festivals || []}
                        onChange={setFestivals}
                        className={styles.filterCheckboxGroup}
                    />
                </div>

                <div className={styles.filterSection}>
                    <Checkbox
                        checked={
                            platforms?.length === PLATFORMS.length &&
                            PLATFORMS.every((el) => platforms.includes(el))
                        }
                        indeterminate={
                            platforms?.length > 0 &&
                            platforms?.length < PLATFORMS.length
                        }
                        onChange={(e) =>
                            setPlatforms(e.target.checked ? PLATFORMS : [])
                        }
                    >
                        <h4 className={styles.filter_heading}>
                            Platform Posts
                        </h4>
                    </Checkbox>
                    <Checkbox.Group
                        options={PLATFORMS_OPTIONS}
                        value={platforms || []}
                        onChange={setPlatforms}
                        className={styles.filterCheckboxGroup}
                    />
                </div>

                <div className={styles.filterSection}>
                    <h4 className={styles.filter_heading}>Post Status</h4>
                    <Checkbox.Group
                        options={[
                            { label: "Pending", value: "pending" },
                            { label: "Scheduled", value: "scheduled" },
                            { label: "Posted", value: "posted" },
                            { label: "Cancelled", value: "cancelled" },
                        ]}
                        value={value.posting_status}
                        onChange={(new_list) =>
                            onChange({ ...value, posting_status: new_list })
                        }
                        className={styles.filterCheckboxGroup}
                    />
                </div>
            </div>

            <div className={styles.filterActions}>
                <Button type="primary" onClick={apply} block={isMobile}>
                    Apply
                </Button>
                <Button
                    block={isMobile}
                    onClick={() => {
                        setPlatforms(PLATFORMS);
                        setFestivals([5, 4, 3]);
                        onChange({
                            platforms: PLATFORMS,
                            festivals: [5, 4, 3],
                        });
                        setOpen(false);
                    }}
                >
                    Reset
                </Button>
            </div>
        </div>
    );

    if (isMobile) {
        return (
            <>
                <span onClick={() => setOpen(true)}>{trigger}</span>
                <Drawer
                    open={open}
                    onClose={() => setOpen(false)}
                    placement="bottom"
                    title="Filters"
                    height="auto"
                    styles={{ body: { padding: "16px 16px 24px" } }}
                >
                    {filterContent}
                </Drawer>
            </>
        );
    }

    return (
        <Popover
            open={open}
            onOpenChange={(new_val) => setOpen(new_val)}
            content={filterContent}
            trigger="click"
            placement="bottomRight"
        >
            {trigger}
        </Popover>
    );
}
